// extracted by mini-css-extract-plugin
export default {"addToCartControl":"R0-z","giftCard":"S0-z","btnContainer":"T0-z","cartButton":"U0-z","disabled":"V0-z"};